import { CircleAlert, CircleSlash } from "lucide-react";
import { FaCar } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import { IoIosTimer } from "react-icons/io";

export type ContractStatus =
  | "Aguardando Embarque"
  | "Concluído"
  | "Veículo Recebido (Estoque)"
  | "Em Trânsito"
  | "Cancelado"
  | "Aguardando Coleta/Recebimento"
  | "Aguardando Reembarque"
  | "Cotação Aprovada"
  | "Veículo Desembarcado (Estoque)"
  | "Veículo Retirado"
  | "-> Encerrar processo"
  | "Aguardando Desembarque"
  | "Veículo Embarcado (Trânsito)"
  | "--";

export const statusText: Record<ContractStatus, string> = {
  "Aguardando Embarque": "Aguardando Embarque",
  Concluído: "Concluído",
  "Veículo Recebido (Estoque)": "Veículo Recebido (Estoque)",
  "Em Trânsito": "Em Trânsito",
  Cancelado: "Cancelado",
  "Aguardando Coleta/Recebimento": "Aguardando Coleta/Recebimento",
  "Aguardando Reembarque": "Aguardando Reembarque",
  "Cotação Aprovada": "Cotação Aprovada",
  "Veículo Desembarcado (Estoque)": "Veículo Desembarcado (Estoque)",
  "Veículo Retirado": "Veículo Retirado",
  "-> Encerrar processo": "Encerrar processo",
  "Aguardando Desembarque": "Aguardando Desembarque",
  "Veículo Embarcado (Trânsito)": "Veículo Embarcado (Trânsito)",
  "--": "--",
};

export const statusVariant: Record<
  ContractStatus,
  "default" | "success" | "destructive"
> = {
  "Aguardando Embarque": "default",
  "Veículo Recebido (Estoque)": "default",
  Concluído: "success",
  "Em Trânsito": "default",
  Cancelado: "destructive",
  "Aguardando Coleta/Recebimento": "default",
  "Aguardando Reembarque": "default",
  "Cotação Aprovada": "success",
  "Veículo Desembarcado (Estoque)": "default",
  "Veículo Retirado": "default",
  "-> Encerrar processo": "destructive",
  "Aguardando Desembarque": "default",
  "Veículo Embarcado (Trânsito)": "default",
  "--": "default",
};

export const statusIcon: Record<ContractStatus, JSX.Element> = {
  "Aguardando Embarque": <IoIosTimer size={20} />,
  "Veículo Recebido (Estoque)": <IoIosTimer size={20} />,
  Concluído: <FaCheck size={20} />,
  "Em Trânsito": <IoIosTimer size={20} />,
  Cancelado: <CircleAlert size={20} />,
  "Aguardando Coleta/Recebimento": <IoIosTimer size={20} />,
  "Aguardando Reembarque": <IoIosTimer size={20} />,
  "Cotação Aprovada": <FaCheck size={20} />,
  "Veículo Desembarcado (Estoque)": <FaCar size={20} />,
  "Veículo Retirado": <FaCar size={20} />,
  "-> Encerrar processo": <CircleAlert size={20} />,
  "Aguardando Desembarque": <IoIosTimer size={20} />,
  "Veículo Embarcado (Trânsito)": <FaCar size={20} />,
  "--": <CircleSlash size={20} />,
};
